import { ObjectSchema, object, string } from 'yup';
import { locale } from './../yup-locale';
import * as yup from 'yup';
import { LibraryCategory } from './../../models/library-category';
yup.setLocale(locale);

export const libraryCategoryNameMaxLen = 50;

export function libraryCategoryValidator(): ObjectSchema<LibraryCategory> {
    return object({
        id: string().uuid().nonNullable().strict(),
        shipyardId: string().uuid().nonNullable().strict(),
        libraryId: string().uuid().nonNullable().strict(),
        name: string().nonNullable().strict().required().max(libraryCategoryNameMaxLen),
    })
        .strict()
        .noUnknown();
}
